export const convertToCorrectPercentage = (value) => {
  const withoutZeroAfterFirstSymbol = value.replace(/^0+(?=[1-9])/, "");
  let filteredValue =
    Number(withoutZeroAfterFirstSymbol) > 100 ? 100 : withoutZeroAfterFirstSymbol;
  if (/^0+$/.test(filteredValue)) {
    filteredValue = "0";
  }
  return filteredValue;
};
